import { privateApi } from 'services';
import { RecentlyUsedContentTag } from './types';

const fetchRecentlyUsedContentTags = async (
    userId: string,
    businessAccountId: string,
): Promise<RecentlyUsedContentTag[]> =>
    privateApi.get<RecentlyUsedContentTag[]>(
        `users/${userId}/recently-used/business-accounts/${businessAccountId}/content-tags`,
    );

const postRecentlyUsedContentTag = async (userId: string, contentTagId: string): Promise<RecentlyUsedContentTag> =>
    privateApi.post<RecentlyUsedContentTag>(`users/${userId}/recently-used/content-tags/${contentTagId}`);

export const RecentlyUsedContentTagsGateway = {
    fetchRecentlyUsedContentTags,
    postRecentlyUsedContentTag,
};
